import classNames from "classnames";
import { Fragment } from "react";

export type SectionHeadingType = {
  text: string;
  highlight?: boolean;
  lineBreak?: boolean;
  customHighlightClass?: string;
}[];

type SectionHeadingPropsType = {
  heading: SectionHeadingType;
  // align?:
  //   | "text-left"
  //   | "text-center"
  //   | "text-right"
  //   | "text-justify"
  //   | "text-start"
  //   | "text-end";
};

const SectionHeading = ({ heading }: SectionHeadingPropsType) => {
  if (heading?.length > 0)
    return (
      <h3
        className={classNames(
          "text-title3 font-semibold text-grey-4 sm:text-title1"
          // `${align ? align : "text-center"}`
        )}
      >
        {heading.map(
          ({ text, highlight, lineBreak, customHighlightClass }, index) => {
            const trimmedText = text.trim(); // Trim the text
            const space = index < heading.length - 1 && !lineBreak ? " " : ""; // Add space if not the last element and no line break

            return (
              <Fragment key={text}>
                {highlight ? (
                  <span
                    className={`${customHighlightClass || "text-purple-3"}`}
                  >
                    {trimmedText}
                  </span>
                ) : (
                  <span>{trimmedText}</span>
                )}
                {lineBreak && <br />}
                {space && <span>{space}</span>}
              </Fragment>
            );
          }
        )}
      </h3>
    );
  else return null;
};

export default SectionHeading;
